"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeLegacyTransferOutput = void 0;
const stepConstants_1 = require("./stepConstants");
/** Legacy DDB/orchestrator step key — only referenced in this compat module. */
const LEGACY_LINK_CUSTOMER_STEP_KEY = "CreateNewSubsidiaryWithinCustomer";
/**
 * Maps legacy DDB output (CreateNewSubsidiaryWithinCustomer) to the current
 * LinkCustomerToTargetSubsidiary shape for UI display and resume safety.
 * Fresh transfers already use the new key and are returned unchanged.
 */
function normalizeLegacyTransferOutput(output) {
    const raw = output;
    const legacy = raw[LEGACY_LINK_CUSTOMER_STEP_KEY];
    const current = raw[stepConstants_1.LINK_CUSTOMER_TO_TARGET_SUBSIDIARY_STEP_KEY];
    if (!legacy || current) {
        return output;
    }
    const migrated = {
        ...raw,
        [stepConstants_1.LINK_CUSTOMER_TO_TARGET_SUBSIDIARY_STEP_KEY]: {
            ...(typeof legacy === "object" && legacy !== null ? legacy : {}),
            name: stepConstants_1.LINK_CUSTOMER_TO_TARGET_SUBSIDIARY_STEP_NAME,
        },
    };
    delete migrated[LEGACY_LINK_CUSTOMER_STEP_KEY];
    return migrated;
}
exports.normalizeLegacyTransferOutput = normalizeLegacyTransferOutput;
